import {EVENT_SOURCE, EVENT_KEY_TYPES, EVENT_STATUS, JOYSTICK_SPEED} from '../../client-data/fps-navigation-constants'
import NavigationCore from "./navigation-core";
import * as Hammer from 'hammerjs';
// import ZingTouch from 'zingtouch-stzhang';
import {CANVAS_ID} from '../../client-data/GlobalConstants';
import {
    DELTA_FORWARD_ACCEL,
    ENABLE_VERTICAL_NAVIGATION,
    MAX_KEY_FORWARD_ACCEL,
    MAX_KEY_TIME_LAPS
} from "../../client-data/clientOptions";

class FPSNavigationControl {
    constructor(elm, useGUI) {
        this.useGUI = useGUI || 'N';
        this.elm = elm || document;

        this.mouseDownHandler = this.mouseDownHandler.bind(this);
        this.mouseMoveHandler = this.mouseMoveHandler.bind(this);
        this.mouseUpHandler = this.mouseUpHandler.bind(this);
        this.keyDownHandler = this.keyDownHandler.bind(this);
        this.keyUpHandler = this.keyUpHandler.bind(this);
        this.update = this.update.bind(this);
        this.onPan = this.onPan.bind(this);
        this.onTap = this.onTap.bind(this);
        this.removeMouseHandlers = this.removeMouseHandlers.bind(this);
        this.restoreMouseDownHandler = this.restoreMouseDownHandler.bind(this);
        this.mouseLeaveHandler = this.mouseLeaveHandler.bind(this);
        this.mouseEnterHandler = this.mouseEnterHandler.bind(this);
        this.mouseLeave = false;

        document.addEventListener('mousedown', this.mouseDownHandler, {passive: false});
        document.addEventListener('keydown', this.keyDownHandler, {passive: false});
        document.addEventListener('keyup', this.keyUpHandler, {passive: false});
        window.addEventListener('contextmenu', function (e) {
            // do something here...
            e.preventDefault();
        }, false);

        window.addEventListener('click', function (e) {
            // do something here...
            e.preventDefault();
            e.stopPropagation();
            return false;
        }, false);

        this.shift = false;
        this.rotateCameraY = 0;
        this.rotateCameraX = 0;
        this.forwardCamera = 0;
        this.panCameraX = 0;
        this.panCameraUp = 0;
        this.keyForwardAccel = 1;
        this.keySideAccel = 0;
        this.canProcess = true;
        this.isTap = false;
        this.isPan = false;
        this.isMouseHandlersRemoved = false;
        this.enableResetKeyForwardAccel = true;
        this.lastKeyStroke = 0;
        this.isLocked = false;
        this.KeyPressedFlag = 0; //tracks the last keyups and keydowns.


        this.isTouchScreen = 'ontouchstart' in window;

        if (this.isTouchScreen) {
            this.hammerManager = new Hammer.Manager(document);
            this.hammerManager.add(new Hammer.Pan({direction: Hammer.DIRECTION_ALL, threshold: 0}));
            this.hammerManager.on("panleft panright panup pandown", this.onPan);
            this.hammerManager.on("hammer.input", function(ev) {
                //console.log(ev.type,ev.isFinal);
                if (ev.isFinal) {
                    this.isLoked = false;
                }
            });


        }

       /* if (this.isTouchScreen) {
            let zt = new ZingTouch.Region(this.elm);
            let longTap = new ZingTouch.Tap({
                maxDelay: 1000
            })
            zt.bind(this.elm, longTap, this.onTap, false);
        }*/

        //todo maybe will need it
        /* this.elm.addEventListener('mouseleave', this.mouseUpHandler, {passive: false});
         this.elm.addEventListener('mouseout', this.mouseDownHandler, {passive: false});*/
    }

    onTap(evt) {

        if (this.isMouseHandlersRemoved) return ;

        if (evt.pointerType === 'mouse') {
            return;
        }
        this.isTap = true;
        this.forwardCamera = 10;
    }

    onPan(evt) {
        if (evt.pointerType === 'mouse') {
            return;
        }

        this.isPan = true;
        if (evt.direction === 2) {
            if (evt.isFinal) {
                this.rotateCameraY = 0;
                this.rotateCameraX = 0;
            } else {
                this.rotateCameraY = (evt.velocityX || 0) * 0.5;
                this.isLocked = true;
                //this.rotateCameraX += (evt.velocity || 0) * 0.0005;
            }
        } else if (evt.direction === 4) {
            if (evt.isFinal) {
                this.rotateCameraY = 0;
                this.rotateCameraX = 0;
            } else {
                this.rotateCameraY = (evt.velocityX || 0) * 0.5;
                this.isLocked = true;
                //this.rotateCameraX += (evt.velocity || 0) * 0.0005;
            }
        } else if (evt.direction === 8) {
            if (evt.isFinal) {
                this.rotateCameraY = 0;
                this.rotateCameraX = 0;
            } else {
                this.rotateCameraX = (evt.velocityY || 0) * 0.5;
                this.isLocked = true;
                //this.rotateCameraX += (evt.velocity || 0) * 0.0005;
            }
        } else if (evt.direction === 16) {
            if (evt.isFinal) {
                this.rotateCameraY = 0;
                this.rotateCameraX = 0;
            } else {
                this.rotateCameraX = (evt.velocityY || 0) * 0.5;
                this.isLocked = true;
                //this.rotateCameraX += (evt.velocity || 0) * 0.0005;
            }
        } else {
            this.rotateCameraY = 0;
            this.rotateCameraX = 0;
        }
    }

    mouseDownHandler(evt) {
        if (this.isTouchScreen) return;
        //todo:commented the line below because added to viewer   webglCanvas.style.pointerEvents = 'none'; which will prevent the canvas from receiving mouse events (for now the css3d element will have the id CANVAS_ID)
        if (evt.target.id !== CANVAS_ID) return;
        document.addEventListener('mousemove', this.mouseMoveHandler, {passive: false});
        document.addEventListener('mouseup', this.mouseUpHandler, {passive: false});
        this.elm.addEventListener('mouseout', this.mouseLeaveHandler, {passive: false});
        this.elm.addEventListener('mouseover', this.mouseEnterHandler);
        this.mouseLeave = false;
        this.rotateCameraY = 0;
        this.rotateCameraX = 0;
        this.panCameraUp = 0;
        this.panCameraX = 0;
        //todo - i commented the code below because was disabling the dropdown on the GUI
        //evt.preventDefault();
    }

    mouseMoveHandler(evt) {

        if (!this.canProcess) {
            this.mouseUpCleanup();
        }
        this.isLocked = true;

        if (!(evt.which === 1 || evt.which === 3)) return;


        if (this.shift || evt.which === 3) {
            this.panCameraX -= (evt.movementX || 0) * 0.001;
            this.panCameraUp += (evt.movementY || 0) * 0.001;

        } else {
            this.rotateCameraY += (evt.movementX || 0) * 0.0005;
            this.rotateCameraX += (evt.movementY || 0) * 0.0005;
        }

    }

    mouseUpHandler(evt) {

        this.mouseUpCleanup();
    }

    mouseLeaveHandler() {
        this.mouseLeave = true;
    }

    mouseEnterHandler(evt) {
        this.mouseLeave = false;

        if (evt.buttons !== 1){
           this.mouseUpCleanup();
        }
    }

    mouseUpCleanup() {

        document.removeEventListener('mousemove', this.mouseMoveHandler);
        document.removeEventListener('mouseup', this.mouseUpHandler);
        this.elm.removeEventListener('mouseout', this.mouseLeaveHandler);
        this.elm.removeEventListener('mouseover', this.mouseEnterHandler);
        this.rotateCameraY = 0;
        this.rotateCameraX = 0;
        this.panCameraUp = 0;
        this.panCameraX = 0;
        this.isLocked = false;
    }

    lockByNavigationManager = ()=> {
        this._lokedByNavigationManager = true;
        this.removeMouseHandlers();
    }

    unlockByNavigationManager = ()=> {
        this._lokedByNavigationManager = false;
        this.removeMouseHandlers();
    }

    //Don't want mouse handlers when joystick mouse handlers are in use
    removeMouseHandlers() {
        if (!this.isMouseHandlersRemoved) {
            document.removeEventListener('mousedown', this.mouseDownHandler);
            this.mouseUpCleanup();
            this.isMouseHandlersRemoved = true;
        }
    }

    restoreMouseDownHandler() {

        // if the lock was requested by the navigation mManager then don't unlock
        if (this._lokedByNavigationManager ) return;

        if (this.isMouseHandlersRemoved) {
            this.isMouseHandlersRemoved = false;
            document.addEventListener('mousedown', this.mouseDownHandler, {passive: false});
        }
    }

    keyHandler(evt, eventStatus) {


        if (this.useGUI === 'N') evt.preventDefault();

        let eventType = -1;
        //console.log("Key pressed =", evt.keyCode, evt.key);

        switch (evt.key) {

            case "ArrowUp": // up
            case "w": // w
                eventType = EVENT_KEY_TYPES.up;
                break;

            case "ArrowLeft": // left
            case "a": // a
                eventType = EVENT_KEY_TYPES.left;
                break;

            case "ArrowDown": // down
            case "s": // s
                eventType = EVENT_KEY_TYPES.down;
                break;

            case "ArrowRight": // right
            case "d": // d
                eventType = EVENT_KEY_TYPES.right;
                break;

            case " ": // space
                eventType = EVENT_KEY_TYPES.space;
                break;

            case "shift": // shift
                this.shift = !(eventStatus === EVENT_STATUS.end);
                break;

        }


        if (eventType !== -1) {
            if (eventStatus === EVENT_STATUS.moving) {
                this.KeyPressedFlag = this.KeyPressedFlag | eventType;
                this.dispatchMovingEvent(this.createKeyMovingEvent(eventType));
            } else {
                this.dispatchEndEvent(this.createKeyEndEvent(eventType));
            }
        }

    }

    keyUpBitwiseHandler = (evt) => {


        switch (evt.key) {

            case "ArrowUp": // up
            case "w": // w

                this.KeyPressedFlag = this.KeyPressedFlag & (~EVENT_KEY_TYPES.up);
                this.forwardCamera = 0;
                break;

            case "ArrowLeft": // left
            case "a": // a

                this.KeyPressedFlag = this.KeyPressedFlag & (~EVENT_KEY_TYPES.left);
                this.rotateCameraY = 0;
                break;

            case "ArrowDown": // down
            case "s": // s

                this.KeyPressedFlag = this.KeyPressedFlag & (~ EVENT_KEY_TYPES.down);
                this.forwardCamera = 0;
                break;

            case "ArrowRight": // right
            case "d": // d

                this.KeyPressedFlag = this.KeyPressedFlag & (~ EVENT_KEY_TYPES.right);
                this.rotateCameraY = 0;
                break;

            case " ": // space
                this.KeyPressedFlag = this.KeyPressedFlag & (~  EVENT_KEY_TYPES.space);
                break;

        }
    }

    keyDownHandler(evt) {
        this.keyHandler(evt, EVENT_STATUS.moving);
    }


    keyUpHandler(evt) {
        this.keyUpBitwiseHandler(evt);
        if (!this.KeyPressedFlag) { //don't send end event if still one key is pressed
            this.keyHandler(evt, EVENT_STATUS.end);
        }
    }

    createEventTemplate() {
        return {
            source: 0,
            keyType: 0,
            posX: 0,
            posY: 0,
            prevX: 0,
            prevY: 0,
            centerX: 0,
            centerY: 0,
            status: 0
        };
    }

    createKeyMovingEvent(keyType) {
        return {
            ...this.createEventTemplate(),
            keyType: keyType,
            source: EVENT_SOURCE.key,
            status: EVENT_STATUS.moving
        }
    }

    createKeyEndEvent(keyType) {
        return {
            ...this.createEventTemplate(),
            keyType: keyType,
            source: EVENT_SOURCE.key,
            status: EVENT_STATUS.end
        }
    }

    incKeyForwardAccel = () => {
        if (this.keyForwardAccel < MAX_KEY_FORWARD_ACCEL) {
            this.keyForwardAccel += DELTA_FORWARD_ACCEL;
        }
    }

    resetKeyForwardAccel = (deltaTime) => {

        this.lastKeyStroke += deltaTime;
        if (this.enableResetKeyForwardAccel) {

            if (this.lastKeyStroke > MAX_KEY_TIME_LAPS) {
                //console.log("resetKeyForwardAccel =", this.lastKeyStroke);
                this.keyForwardAccel = 1;
                this.lastKeyStroke = 0;
            }

        } else {
            this.lastKeyStroke = 0;
        }


    }

    dispatchMovingEvent(keyMovingEvent) {
        let {source, keyType} = keyMovingEvent;
        if (source === EVENT_SOURCE.key) {
            this.enableResetKeyForwardAccel = false;
            if (keyType === EVENT_KEY_TYPES.up) {
                this.forwardCamera = 1.5;
               this.incKeyForwardAccel();
            } else if (keyType === EVENT_KEY_TYPES.down) {
                this.forwardCamera = -1.5;
                this.incKeyForwardAccel();
            } else if (keyType === EVENT_KEY_TYPES.left) {
                // this.panCameraX = +0.1 + this.keySideAccel;
                this.rotateCameraY = +0.2 + this.keySideAccel;
                // this.keySideAccel += 0.05;
            } else if (keyType === EVENT_KEY_TYPES.right) {
                // this.panCameraX = -0.1 - this.keySideAccel;
                this.rotateCameraY = -0.2 - this.keySideAccel;
                // this.keySideAccel += 0.05;
            }
            this.isLocked = true;
        }

    }

    dispatchEndEvent(keyMovingEvent) {
        let {source, keyType} = keyMovingEvent;
        if (source === EVENT_SOURCE.key) {
            if (keyType === EVENT_KEY_TYPES.up || keyType === EVENT_KEY_TYPES.down) {
                this.forwardCamera = 0;
            }
            if (keyType === EVENT_KEY_TYPES.left || keyType === EVENT_KEY_TYPES.right) {
                // this.panCameraX = 0;
                this.rotateCameraY = 0;
            }
            this.enableResetKeyForwardAccel = true;
            this.isLocked = false;

            // this.keySideAccel = 0;
        }
    }

    update(camera, deltaTime, colliderContainer,cameraNavMeshHandler,canProcess = true,) {
        this.canProcess = canProcess;
        if (!canProcess) {
            this.removeMouseHandlers();
            return false;
        } else {
            this.restoreMouseDownHandler();
            //restoreMouseDownHandler might not set isMouseHandlersRemoved to false because the lock might be requested by the NavigationManager
            if ( this.isMouseHandlersRemoved) return false;
        }
        if (this.mouseLeave) return false;
        if (  this.isLocked ) {
            cameraNavMeshHandler.moveForward(this.forwardCamera * deltaTime * this.keyForwardAccel);
            NavigationCore.rotateCameraXY2(camera, this.rotateCameraX * deltaTime * JOYSTICK_SPEED, this.rotateCameraY * deltaTime * JOYSTICK_SPEED);
            cameraNavMeshHandler.moveSide(this.panCameraX * deltaTime * JOYSTICK_SPEED);
            if (ENABLE_VERTICAL_NAVIGATION) {
                NavigationCore.moveUp2(camera, this.panCameraUp * deltaTime * JOYSTICK_SPEED, colliderContainer);
            }
        }

        if (this.isTap) {
            this.isTap = false;
            this.forwardCamera = 0;

        }
        if (this.isPan) {
            this.isPan = false;
            this.rotateCameraX = 0;
            this.rotateCameraY = 0;
        }
        this.resetKeyForwardAccel(deltaTime);
        return  this.isLocked;
    }
}

export default FPSNavigationControl;
